import { Record } from 'immutable';

const VdpUsedRecord = Record({
    invalidState: false,
    exchangePolicy: {
        days: 7,
        kms: 1000,
    },
});

class VdpUsed extends VdpUsedRecord {}

export default VdpUsed;
